import DirectoryProfileContentBlock from './DirectoryProfileContentBlock';

export default DirectoryProfileContentBlock;
